function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import Collector from "./collector";
import Logger from "./logger";
import Translator from "../components/common/translation";
import { _Environment, _Api } from "./core";
var getCurrentDate = function getCurrentDate() {
  var date = new Date();
  date.setHours(0, 0, 0, 0);
  return Math.floor(date.getTime() / 1000);
};

/**
 * This object groups all functions used inside the "@/components/contexts/workflow.jsx"
 */
var WorkFlowService = {
  /**
   * Initialize the collector in three questions : Which Diag ? Which Bloc ? Which Question ?
   *
   * @param {number} diagId
   * @param {object} notifier
   * @param {function} dispatcher
   * @param {object} actionTypes
   */
  processIntialization: function processIntialization(diagId, notifier, dispatcher, actionTypes) {
    var UPDATE_DIAG = actionTypes.UPDATE_DIAG,
      UPDATE_CURR_BLOC = actionTypes.UPDATE_CURR_BLOC,
      UPDATE_CURR_QUESTION = actionTypes.UPDATE_CURR_QUESTION,
      UPDATE_CURR_ORDER = actionTypes.UPDATE_CURR_ORDER,
      MAIN_LOADER = actionTypes.MAIN_LOADER,
      UPDATE_RESPONSES = actionTypes.UPDATE_RESPONSES,
      IS_FINISHED = actionTypes.IS_FINISHED,
      HAS_NOT_STARTED = actionTypes.HAS_NOT_STARTED;
    dispatcher({
      type: MAIN_LOADER,
      value: true
    });
    Collector.getDiag(diagId).then(function (diagResponse) {
      Collector.getNextQuestion(diagId, '0_b.-1_q', {}).then(function (response) {
        var _question$id, _question$alias;
        var data = response.data;
        var diagnostic = diagResponse.data;
        Collector.sortDiagnostic(diagnostic);
        if (!data.question && !data.message) {
          Logger.error('Init Collector', 'no question found', {
            data: data
          });
          notifier.error( /*#__PURE__*/React.createElement(Translator, {
            id: "initialization"
          }), /*#__PURE__*/React.createElement(Translator, {
            id: "no_question_found"
          }));
          return;
        }
        if (data.message) {
          notifier.error( /*#__PURE__*/React.createElement(Translator, {
            id: "initialization"
          }), /*#__PURE__*/React.createElement(Translator, {
            id: "collectorapp_".concat(data.message)
          }));
          dispatcher({
            type: data.message === 'diagnostic_ended' ? IS_FINISHED : HAS_NOT_STARTED,
            value: true
          });
          return;
        }
        var question = JSON.parse(data.question);
        var questionAnalyzer = {
          questionId: (_question$id = question.id) !== null && _question$id !== void 0 ? _question$id : 'NA',
          questionAlias: (_question$alias = question.alias) !== null && _question$alias !== void 0 ? _question$alias : 'NA',
          diag: diagId,
          today: getCurrentDate(),
          type: 'start'
        };
        _Api.post('/analytics/diagnostics/patch_question', JSON.stringify(questionAnalyzer));
        var currentResponse = WorkFlowService.updateResponsesFromQuestionApi(data, {});
        dispatcher({
          type: UPDATE_RESPONSES,
          value: currentResponse
        });
        dispatcher({
          type: UPDATE_CURR_QUESTION,
          value: question
        });
        dispatcher({
          type: UPDATE_CURR_ORDER,
          value: data.order
        });
        var bloc = Collector.getBloc(diagResponse.data, 0);
        dispatcher({
          type: UPDATE_DIAG,
          value: diagResponse.data
        });
        dispatcher({
          type: UPDATE_CURR_BLOC,
          value: bloc
        });
        dispatcher({
          type: MAIN_LOADER,
          value: false
        });
      }).catch(function (e) {
        Logger.error('Init failed', 'failure QUESTIOn', e);
        if (notifier) {
          notifier.error( /*#__PURE__*/React.createElement(Translator, {
            id: "collectorapp_server_error"
          }), /*#__PURE__*/React.createElement(Translator, {
            id: "collectorapp_error_cannot_get_diagnostic"
          }));
        }
      });
    }).catch(function (e) {
      Logger.error('Init failed', 'failure', e);
      if (notifier) {
        notifier.error( /*#__PURE__*/React.createElement(Translator, {
          id: "collectorapp_server_error"
        }), /*#__PURE__*/React.createElement(Translator, {
          id: "collectorapp_error_cannot_get_diagnostic"
        }));
      }
    });
  },
  /**
   * Check that all the responses have a value
   */
  responsesChecker: function responsesChecker(responses) {
    var current = responses && responses.responses ? responses.responses : null;
    if (!current || Object.keys(current).length === 0) {
      return false;
    }
    var isValid = false;
    Object.keys(current).map(function (key) {
      if (!current[key]) {
        return false;
      }
      isValid = true;
      return true;
    });
    return isValid;
  },
  // Permet de supprimer les références circulaire dans l'objet de
  // facon plutôt safe.
  removeCircular: function removeCircular(obj) {
    if (!obj || Object.keys(obj).length === 0) {
      return;
    }
    var seen = new Map();
    var _recurse = function recurse(obj) {
      seen.set(obj, true);
      if (null === obj) return;
      Object.entries(obj).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];
        if (_typeof(v) !== 'object') return;
        if (seen.has(v)) delete obj[k];else _recurse(v);
      });
    };
    _recurse(obj);
  },
  /**
   * Check what content is needed for the next view.
   *
   * @param {number} index
   * @param {object} collector
   * @param {function} dispatcher
   * @param {object} actionsTypes
   * @param {object} notifier
   */
  processQuestionChange: function processQuestionChange(index, collector, dispatcher, actionsTypes, notifier, analytics) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var diag, currentQuestion, currentBloc, currentOrder, responses, historic, diagId, LOADER_QUESTION, END, UPDATE_RESPONSES, QUESTION_TIMER_START, isRequired, isCorrectResponses, response, nextContent, nextQuestion, currentResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            diag = collector.diag, currentQuestion = collector.currentQuestion, currentBloc = collector.currentBloc, currentOrder = collector.currentOrder, responses = collector.responses, historic = collector.historic, diagId = collector.diagId;
            LOADER_QUESTION = actionsTypes.LOADER_QUESTION, END = actionsTypes.END, UPDATE_RESPONSES = actionsTypes.UPDATE_RESPONSES, QUESTION_TIMER_START = actionsTypes.QUESTION_TIMER_START;
            WorkFlowService.removeCircular(responses);
            dispatcher({
              type: LOADER_QUESTION,
              value: true
            });
            _context.prev = 4;
            if (!(index === -1)) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return", WorkFlowService.getQuestionFromHistoric(historic, dispatcher, actionsTypes, currentOrder, diagId, analytics));
          case 7:
            if (!currentQuestion) {
              Logger.error('processQuestionChange | no currentQuestion', '---', {
                collector: collector
              });
            }
            isRequired = (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.required) || false;
            isCorrectResponses = WorkFlowService.responsesChecker(Collector.getCurrentOrderResponses(currentOrder, responses));
            if (!(!isCorrectResponses && isRequired)) {
              _context.next = 14;
              break;
            }
            notifier.warning( /*#__PURE__*/React.createElement(Translator, {
              id: "question"
            }), /*#__PURE__*/React.createElement(Translator, {
              id: "question_is_required"
            }));
            dispatcher({
              type: LOADER_QUESTION,
              value: false
            });
            return _context.abrupt("return", false);
          case 14:
            _context.next = 16;
            return Collector.getNextQuestion(diag.id, currentOrder, responses);
          case 16:
            response = _context.sent;
            nextContent = response.data; // si les deux sont différents on supprime
            //  this.deleteNextQuestionInHistoric(historic, nextContent, responses);
            if (!(!nextContent.order && !nextContent.question)) {
              _context.next = 23;
              break;
            }
            dispatcher({
              type: END,
              value: true
            });
            dispatcher({
              type: LOADER_QUESTION,
              value: false
            });
            analytics.post.question('start', {
              id: 0,
              alias: 'q-end'
            });
            return _context.abrupt("return", true);
          case 23:
            nextQuestion = JSON.parse(nextContent.question);
            nextQuestion.previousQuestionId = currentQuestion.id;
            analytics.post.question('start', nextQuestion);
            _this.insertInsideHistoric(historic, currentOrder, currentQuestion, currentBloc);
            currentResponse = WorkFlowService.updateResponsesFromQuestionApi(nextContent, responses);
            dispatcher({
              type: QUESTION_TIMER_START,
              value: new Date().getTime()
            });
            if (currentResponse) {
              dispatcher({
                type: UPDATE_RESPONSES,
                value: currentResponse
              });
            }
            WorkFlowService.dispatchElement(nextContent, dispatcher, historic, actionsTypes);
            _context.next = 38;
            break;
          case 33:
            _context.prev = 33;
            _context.t0 = _context["catch"](4);
            Logger.warn('next question', 'error', {
              e: _context.t0,
              currentOrder: currentOrder
            });
            notifier.error( /*#__PURE__*/React.createElement(Translator, {
              id: "collectorapp_server_error"
            }), /*#__PURE__*/React.createElement(Translator, {
              id: "collectorapp_error_cannot_get_question"
            }));
            dispatcher({
              type: LOADER_QUESTION,
              value: false
            });
          case 38:
            return _context.abrupt("return", false);
          case 39:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 33]]);
    }))();
  },
  insertInsideHistoric: function insertInsideHistoric(historic, currentOrder, question, bloc) {
    var canInsert = true;
    var foundIndex = null;
    historic.list.forEach(function (element, index) {
      if (element.order === currentOrder) {
        canInsert = false;
        foundIndex = index;
      }
    });
    if (canInsert) {
      var _historic$current$ind, _historic$current;
      historic.list.push({
        order: currentOrder,
        previous: (_historic$current$ind = (_historic$current = historic.current) === null || _historic$current === void 0 ? void 0 : _historic$current.index) !== null && _historic$current$ind !== void 0 ? _historic$current$ind : 0,
        question: WorkFlowService.cloneObject(question),
        bloc: bloc
      });

      // @fix ici on met à jour l'index de la question courante
      historic.list[historic.list.length - 1].index = historic.list.length - 1;
      // on efface le courant, car à chaque fois qu'on avance, on re-telecharge les données.
      historic.current = historic.list[historic.list.length - 1];
      historic.current.index = historic.list.length - 1;
    } else if (foundIndex >= 0) {
      historic.current = historic.list[foundIndex];
      historic.current.index = foundIndex;
    }
  },
  /**
   * Get the previous or the next question from the historic (if exist)
   *
   * @param {object} historic
   * @param {function} dispatcher
   * @param {object} actions
   * @param {string|null} indexType
   */
  getQuestionFromHistoric: function getQuestionFromHistoric(historic, dispatcher, actions, currentOrder, diagId, analytics) {
    try {
      // En faite la question courant est la précédente...
      var index = historic.current.index;
      var element = historic.list[index];
      var newHistoric = _objectSpread({}, historic);
      if (!element) {
        return false;
      }
      element.index = index;
      // donc le current ici doit être la précédente...
      newHistoric.current = newHistoric.list[element.previous];
      var currQuest = element.question;
      if (typeof element.question === 'string') {
        currQuest = JSON.parse(element.question);
      }
      analytics.post.question('start', currQuest);

      // eslint-disable-next-line no-param-reassign
      WorkFlowService.dispatchElement(element, dispatcher, newHistoric, actions);
      return true;
    } catch (e) {
      // this message will be shown only in dev env.
      Logger.error('workflow.js', "Error fetching {order: ".concat(currentOrder, " } question"), e);
      return false;
    }
  },
  deleteNextQuestionInHistoric: function deleteNextQuestionInHistoric(historic, toCompare, response) {
    try {
      var index = !historic.current ? historic.list.length - 1 : historic.current.index + 1;
      if (!historic.current) {
        return true;
      }
      var element = historic.list[index];
      if (!element) {
        return true;
      }
      if (element && element.order !== toCompare.order) {
        historic.list.slice(index, 1);
        var orderExploder = element.order.split('.');
        var nextOrder = null;
        var maxLength = orderExploder.length - 1;
        orderExploder.forEach(function (order, index) {
          if (!nextOrder) {
            nextOrder = response[order];
            if (index === maxLength) {
              delete response[order];
            }
          } else {
            if (index === maxLength) {
              delete nextOrder[order];
            }
            nextOrder = nextOrder[order];
          }
        });
      }
      return true;
    } catch (e) {
      // this message will be shown only in dev env.
      Logger.error('workflow.js', "Error deleting question from historic", e);
      return false;
    }
  },
  /**
   * Send to context
   *
   * @param {object} element
   * @param {function} dispatcher
   * @param {object} historic
   * @param {object} actions
   */
  dispatchElement: function dispatchElement(element, dispatcher, historic, actions) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var LOADER_QUESTION, UPDATE_CURR_QUESTION, UPDATE_CURR_BLOC, UPDATE_CURR_ORDER, UPDATE_HISTORIC, question, bloc;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            LOADER_QUESTION = actions.LOADER_QUESTION, UPDATE_CURR_QUESTION = actions.UPDATE_CURR_QUESTION, UPDATE_CURR_BLOC = actions.UPDATE_CURR_BLOC, UPDATE_CURR_ORDER = actions.UPDATE_CURR_ORDER, UPDATE_HISTORIC = actions.UPDATE_HISTORIC;
            question = element.question, bloc = element.bloc;
            if (typeof question === 'string') {
              question = JSON.parse(question);
            }
            if (typeof bloc === 'string') {
              bloc = JSON.parse(bloc);
            }
            question.loop = question.loop || element.loop;
            question.loop_label = question.loop_label || element.loop_label;
            dispatcher({
              type: UPDATE_HISTORIC,
              value: historic
            });
            dispatcher({
              type: UPDATE_CURR_ORDER,
              value: element.order
            });
            dispatcher({
              type: UPDATE_CURR_BLOC,
              value: bloc
            });
            dispatcher({
              type: UPDATE_CURR_QUESTION,
              value: question
            });
            dispatcher({
              type: LOADER_QUESTION,
              value: false
            });
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  /**
   * Strange but true way of copying an array without the reference
   */
  cloneObject: function cloneObject(object) {
    return JSON.parse(JSON.stringify(object));
  },
  updateResponsesFromQuestionApi: function updateResponsesFromQuestionApi(nextContent, responses) {
    var question = JSON.parse(nextContent.question);
    var contentResponses = nextContent.responses_matches;
    question.loop = nextContent.loop;
    question.loop_label = nextContent.loop_label;
    if (!responses) {
      return responses;
    }
    if (contentResponses) {
      // @fix, currentResponse doit toujours avoir une valeur
      var currentResponses = Collector.getCurrentOrderResponses(nextContent.order, responses) || {};
      currentResponses.type = nextContent.type;
      Object.keys(contentResponses).forEach(function (alias) {
        var response = contentResponses[alias];
        var aliasCurrentResponse = Collector.getQuestionResponseByKey(nextContent.order, responses, alias, currentResponses);
        if (aliasCurrentResponse) {
          return;
        }
        if (!Array.isArray(response)) {
          Collector.insertQuestionResponse(alias, response, nextContent.order, responses, question, nextContent.type);
        } else {
          for (var i = 0; i < response.length; i++) {
            Collector.insertQuestionResponse(alias, response[i].value || response[i], nextContent.order, responses, question, nextContent.type);
          }
        }
      });
    }
    return responses;
  },
  getResponseLoopFromHistoric: function getResponseLoopFromHistoric(historic, currentQuestion) {
    var loopAlias = currentQuestion.loop;
    var elements = historic.list;
    var responses = null;
    for (var i = 0; i < elements.length; i++) {
      responses = elements[i].question.expectedResponses;
      for (var r = 0; r < responses.length; r++) {
        var _ref3 = responses[r] || {},
          alias = _ref3.alias,
          value = _ref3.value;
        if (alias === loopAlias || value === alias) {
          return responses[r];
        }
      }
    }
    return null;
  }
};
export default WorkFlowService;